import { apiBaseUrl } from 'api/api';

const routes: Record<string, string> = {
  '/': 'home', '/dashboard': 'dashboard', '/login': 'authentication', '/logout': 'authentication',
  '/join-now': 'registration', '/forgot': 'authentication', '/update-password': 'authentication',
  '/confirmaccount': 'registration', '/mfa-verify': 'authentication', '/my-profile': 'profile',
  '/my-profile-category-question': 'profile', '/my-surveys': 'surveys', '/short-survey': 'surveys',
  '/most-point': 'surveys', '/accountsection': 'account', '/my-referral': 'referrals',
  '/history': 'history', '/wallet-history': 'history', '/virtual-wallet': 'rewards',
  '/survey-redeem': 'rewards', '/survey': 'rewards', '/otp': 'rewards',
  '/unsubscribe': 'preferences', '/unsubscribe-dm': 'preferences', '/email-preferences': 'preferences',
  '/alert': 'notifications', '/raise-query': 'support', '/contact': 'support',
  '/admin/user-queries': 'administration', '/more': 'navigation', '/faq': 'help', '/about': 'about',
  '/privacy-policy': 'legal', '/terms-and-conditions': 'legal', '/old': 'surveys',
  '/success': 'surveys', '/terminate': 'surveys', '/security-terminate': 'surveys', '/quota-full': 'surveys',
};

export function activityPage(pathname: string): { page: string; module: string } {
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/';
  if (path.startsWith('/redeem/form/')) return { page: '/redeem/form/:service', module: 'rewards' };
  return routes[path] ? { page: path, module: routes[path] } : { page: '/unknown', module: 'navigation' };
}

function eventId(): string {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Shared, best-effort logging. Never pass input values, text content, URLs or user IDs. */
export async function logActivity(pathname: string): Promise<void> {
  try {
    const body = JSON.stringify({ eventId: eventId(), page: activityPage(pathname).page });
    const token = localStorage.getItem('access_token');
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const response = await fetch(`${apiBaseUrl}/api/activity`, {
          method: 'POST', credentials: 'include', keepalive: true,
          headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body,
        });
        if (response.ok || (response.status < 500 && response.status !== 429)) return;
      } catch { /* Retry this same event ID, never the application action. */ }
      if (attempt < 2) await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
    }
  } catch { /* Logging must never interrupt user interaction, including restricted storage. */ }
}
